import React, { useState } from "react";
import clsx from "clsx/lite";

const ErrorHoverButton = ({ text, errorMessage, isDisabled, onClick, className, id = "" }) => {
	const [isHovered, setIsHover] = useState();

	return (
		<>
			{errorMessage && isHovered && (
				<div className="relative w-full">
					<div className="absolute z-[1] right-0 rounded bottom-0">
						<div className="downward-error-indicator">
							<span className="!text-left">{errorMessage}</span>
						</div>
					</div>
				</div>
			)}
			<div
				className="w-full flex justify-center my-1.5"
				onMouseOver={() => isDisabled && errorMessage ? setIsHover(true) : 0}
				onMouseLeave={() => isDisabled && errorMessage ? setIsHover(false) : 0}
			>
				<button
					id={id}
					onClick={onClick}
					disabled={isDisabled}
					className={clsx("btn-primary text-small px-0 py-3 text-center hover:opacity-80 hover:scale-100 w-full", className)}
				>
					{text}
				</button>
			</div>
		</>
	);
};

export default ErrorHoverButton;